@if (variant === 'redesign') {
    <div class="tree-select-spinner" role="status" aria-live="polite" aria-label="loading">
        <svg-icon class="tree-select-spinner__icon" src="/assets/icons/spinner.svg" aria-hidden="true"></svg-icon>
    </div>
} @else {
    <p-progressSpinner ariaLabel="loading"></p-progressSpinner>
}
